import { useImageAttachment } from "~/hooks/useImageAttachment";
import imgBuilding from "~/assets/images/icons/building.svg";
import { AttachmentImage } from "~/common/components/image/AttachmentImage";

export const FundItemListImage = ({
  imageId,
  children,
}: {
  imageId?: number;
  children?: React.ReactNode;
}) => {
  const image = useImageAttachment(imageId, "large");

  return (
    <div className="tw:flex tw:justify-start tw:items-center tw:w-[100px] tw:md:w-[250px]">
      {imageId !== undefined ? (
        <>
          <AttachmentImage
            image={image}
            className="tw:!h-[75px] tw:md:!h-[126px]"
          />
          {children}
        </>
      ) : (
        <div className="tw:flex tw:flex-col tw:justify-center tw:items-center tw:ml-[30px] tw:md:ml-[45px] tw:!h-[75px] tw:md:!h-[126px]">
          <img
            src={imgBuilding}
            alt="building icon"
            className="tw:w-12 tw:h-12 tw:mb-2"
          />
          {children}
        </div>
      )}
    </div>
  );
};
